import React, { useState, useEffect } from 'react';
import RoomService from './RoomService';
import Alert from 'react-bootstrap/Alert';
import filterFieldsForList from '../../common/functions/filterFieldsForList';
import filterDataForList from '../../common/functions/filterDataForList';
import schema from './jsonSchema';
import AdvanceList from '../../common/AdvanceList';
import { useNavigate } from 'react-router-dom';
import useHeaderGenerator from '../../common/functions/useHeaderGenerator';

const RoomList = () => {
  const [data, setData] = useState();
  const [columns, setColumns] = useState([]);
  const [error, setError] = useState('');
  const [noDataToShow, setNoDataToShow] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const jsonSchema = schema;
    const fieldsForList = filterFieldsForList(jsonSchema);
    setColumns(fieldsForList);

    RoomService.retrieveAllRoomByAccount()
      .then(data => {
        setData(filterDataForList(data, columns.map(c => c.accessor)));
        setNoDataToShow(!data.length > 0);
      })
      .catch(error => setError({ error: error.message }));
  }, [noDataToShow]);
  const buttonsConf = [
    {
      name: 'Create a new Room',
      type: 'submit',
      variant: 'info',
      onClick: () => {
      console.log('Create a new Room');
      navigate('/app/hospitality/rooms/create-form');
      }
    },
    {
      name: 'Save Draft',
      type: 'submit',
      variant: 'success',
      onClick: () => {
        console.log('Save Draft');
      }
    }
  ];
  const headerGenerated = useHeaderGenerator(
 'Create Room',
 ' ',
 buttonsConf 
);
  return (
    <>
    {headerGenerated}

      {noDataToShow && (
        <Alert key="warning" variant="warning">
          There's not any Room to show. Let's create a new one!
        </Alert>
      )}
      {data && (
        <AdvanceList columns={columns} data={data} />
      )}
    </>
  );
};

export default RoomList;